import { Component, OnInit } from "@angular/core"
import { CcParamsGen } from "@app/cc-params-gen/cc-params-gen"

@Component({
	selector: "app-cc-params-security",
	template: `
		<app-cc-sections
			name="security"
			section="security"
		/>
		<div class="container-wrap">
			<hr class="separation-line" />

			<div>
				<div class="row">
					<div class="col-6 col-md-2 ">
						<label>{{ "time_to_logout" | langVal }}</label>
						<app-gen-input
							[tabindex]="63"
							[actualObj]="configcliniq"
							[errors]="errors"
							fieldName="time_to_logout"
							(keyupEvent)="validateAndSave()"
						/>
					</div>
				</div>
				@if (!permsService.owner_has_users) {
					<div class="row">
						<div class="col-12 col-lg-2 ">
							<label>{{ "is_google2fa" | langVal }}</label>
							<app-gen-button-group
								[actualObj]="configcliniq"
								fieldName="is_google2fa"
								optionsListName="yes_no_opts"
								(changeEvent)="validateAndSave()"
							/>
						</div>
						<div class="action-buttons p-0 col-12 col-lg-2 ">
							<button
								class="btn btn-primary modal-btns"
								(click)="store.openGoogle2faModal()"
							>
								<!--preIcon="changePassword"-->
								{{ "get_2fa_key" | langVal }}
							</button>
						</div>
					</div>
				}
			</div>
		</div>
			`,
})
export class CcParamsSecurityComponent extends CcParamsGen {
	saveObjName: string = "security" //which part to save while updating

	openChangePassword() {
		this.modalService.openMulti("change-password")
	}
}
